import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { CommonUtilsModule } from "../common-utils/common-utils.module";

import { CommonMultiselectFilterActionsDirective } from "./actions.directive";
import { CommonMultiselectFilterComponent } from "./common-multiselect-filter.component";
import { multiselectFilterStatePropProvider } from "./state-props";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CommonUtilsModule,
    ],
    exports: [
        CommonMultiselectFilterComponent,
        CommonMultiselectFilterActionsDirective,
    ],
    declarations: [
        CommonMultiselectFilterComponent,
        CommonMultiselectFilterActionsDirective,
    ],
    providers: [
        CommonMultiselectFilterActionsDirective,
        multiselectFilterStatePropProvider,
    ],
})
export class CommonMultiselectFilterModule {
}
